/* Native product forms own basket and variant state. Radar adds only context and content. */
if (!window.ispRadarBound) {
  window.ispRadarBound = true;
  const saved = new Map();
  function sync() {
    document.querySelectorAll('product-info').forEach(root => {
      const details = root.closest('section')?.querySelector('[data-radar-details]');
      if (!details) return;
      const select = root.querySelector('variant-selects select');
      const power = select?.value;
      // Dawn briefly keeps the old picker in a hidden transition node. Never pair it with the new select.
      const picker = select?.closest('variant-selects').querySelector('[data-radar-picker]');
      if (select && !picker) select.closest('.select').hidden = false;
      if (picker && select) {
        picker.hidden = false;
        select.closest('.select').hidden = true;
        const choice = picker.querySelectorAll('[data-radar-choice]')[select.selectedIndex];
        if (choice) {
          const label = picker.querySelector('[data-radar-choice-label]');
          const selectedText = select.selectedOptions[0].textContent.trim();
          if (label.textContent !== selectedText) label.textContent = selectedText;
          picker.querySelector('summary').setAttribute('aria-label', 'Power supply: ' + selectedText);
          const photo = picker.querySelector('[data-radar-choice-photo]');
          if (photo.src !== choice.querySelector('img').src) photo.src = choice.querySelector('img').src;
        }
      }
      details.querySelectorAll('[data-radar-power]').forEach(p => { const hide = p.dataset.radarPower !== power; if (p.hidden !== hide) p.hidden = hide; });
      const input = root.querySelector('[data-radar-speed]');
      if (input && saved.has(root.id) && input.value !== saved.get(root.id)) input.value = saved.get(root.id);
    });
  }
  document.addEventListener('input', e => { if (e.target.matches('[data-radar-speed]')) saved.set(e.target.closest('product-info').id, e.target.value); });
  document.addEventListener('change', sync);
  document.addEventListener('click', e => {
    const button = e.target.closest('[data-radar-choice]');
    if (!button) return;
    const picker = button.closest('[data-radar-picker]');
    const select = picker.closest('variant-selects').querySelector('select');
    select.selectedIndex = Number(button.dataset.radarChoice);
    picker.open = false;
    picker.querySelector('summary').focus();
    select.dispatchEvent(new Event('change', {bubbles:true}));
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { const picker = e.target.closest('[data-radar-picker]'); if(picker) { picker.open=false; picker.querySelector('summary').focus(); } } });
  let queued = false;
  new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; sync(); }); } }).observe(document.body, {childList:true,subtree:true});
  sync();
}
